import { format } from 'date-fns'

import { EMPTY_STRING } from '../../../constants/common'
import { DATE_HOURS_FORMAT } from '../../../constants/date'

import {
  CHATROOM_SYSTEM_MESSAGE_TRANSLATION_KEY,
  CHATROOM_SYSTEM_MESSAGE_TYPE,
} from './ChatroomSystemMessage.constants'

export function isChatroomSystemMessageAddUserWithComment(message) {
  return (
    message?.message_type === CHATROOM_SYSTEM_MESSAGE_TYPE.AddUserWithComment
  )
}

export function formatChatroomSystemMessageTime(created) {
  if (!created) {
    return EMPTY_STRING
  }

  const date = new Date(created)

  if (Number.isNaN(date.getTime())) {
    return EMPTY_STRING
  }

  return format(date, DATE_HOURS_FORMAT)
}

export function getChatroomSystemMessageTranslationKey(message) {
  if (
    isChatroomSystemMessageAddUserWithComment(message) &&
    !message?.comment?.trim()
  ) {
    return CHATROOM_SYSTEM_MESSAGE_TRANSLATION_KEY[
      CHATROOM_SYSTEM_MESSAGE_TYPE.AddUser
    ]
  }

  return CHATROOM_SYSTEM_MESSAGE_TRANSLATION_KEY[message?.message_type] || null
}
